import { render, staticRenderFns } from "./Announcements.vue?vue&type=template&id=784ec3ec&scoped=true"
import script from "./Announcements.vue?vue&type=script&lang=js"
export * from "./Announcements.vue?vue&type=script&lang=js"
import style0 from "./Announcements.vue?vue&type=style&index=0&id=784ec3ec&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ec3ec",
  null
  
)

export default component.exports